import { oc } from '@orpc/contract';
import { deletePublishedResultInputSchema, deletePublishedResultOutputSchema } from '../schemas/vehicles.schemas.js';
export const deletePublishedResultContract = oc
    .route({
    method: 'DELETE',
    path: '/vehicles/{vehicleId}/published-results/{id}',
    tags: ['Vehicles'],
    summary: 'Remove a published reference figure',
    description: 'MANAGER only.',
})
    .input(deletePublishedResultInputSchema)
    .output(deletePublishedResultOutputSchema);
//# sourceMappingURL=delete-published-result.contract.js.map